import { clsx } from "clsx";
import type { InputHTMLAttributes } from "react";

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={clsx(
        "min-h-12 w-full rounded-lg border border-slate-500/30 bg-slate-950/40 px-4 text-sm text-white placeholder:text-slate-500",
        className
      )}
      {...props}
    />
  );
}
